export const homePageClientsAndPartners = [
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/raymond-logo_ph4bul.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/Tech_Mahindra_New_Logo.svg_qfol0q.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/portea-logo_whkrgu.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/Novotel_Logo_bjrntp.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/LOreal-Emblem_v3oyvn.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/Nestle-Logo_b2zzmw.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/925643839s_wf96bc.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/2560px-Max_Healthcare_logo.svg_hf9qnc.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/download_srxhrn.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/bata-logo-png-transparent_skbtkn.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/HDFC_Bank_Logo.svg_iumyrb.png",
    },
    {
      link: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/clients_partners/Axis_Bank_logo_logotype_y3de8i.png",
    },
  ];
export const university_logo=  [
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_University_of_Hertfordshire_Dubai.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_University_of_Law.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Munich_University_of_Digital_Technologies.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_NIT_TUHH.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Neoma_Business_School.jpg"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_SRH_University_of_Applied_Sciences.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Sigmund_University_of_applied_sciences.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_UE_Applied_Sciences.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_ICN_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_IPSA.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Kedge_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Munich_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_ESSCA_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_EU_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Esdes_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_GISMA_Business_School.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_HTMi.jpg"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Harriot_Watt_University_Dubai.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_BHMS.jpg"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Brunel_University_London.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Canterbury_Christ_Church.png"
    },
    {
      link : "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_DE_Vinci.png"
    }
 ];

  export const keysector_icons = [
    
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Healthcare_huxrtl.svg",
       "name":"Healthcare",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Retail_bf14f1.svg",
       "name":"Retail",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/BFSI_mocoa0.svg",
       "name":"BFSI",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Logistics_h87dda.svg",
       "name":"Logistics",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Hospitality_oi0r8m.svg",
       "name":"Hospitality",
    },
     {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/E-commerce_dhwrs4.svg",
       "name":"E-Commerce",
    },
     {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Manufacturing_dmklk9.svg",
       "name":"Manufacturing",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Construction_qghuug.svg",
       "name":"Construction",
    },
     {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Automobile_fsrpph.svg",
       "name":"Automobile",
    },
     {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/IT_ITES_ejgejj.svg",
       "name":"IT & ITeS",
    },
    {
       "link":"https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/key_sectors/Apparel_Textile_fkeigu.svg",
       "name":"Apparel & Textile",
    }
]

 export const featuredCourses = [
  {
    name:'Essentials Of Business Communication',
    img:'https://dcbdjixrxgopu.cloudfront.net/cglms/uploads/medias/courses/business_communication.jpg',
    desc:'Learn to communicate confidently, smartly and efficiently to find success in your work environment and feel like a winner.'
  },
  {
    name:'Diploma in Hardware Networking',
    img:'https://dcbdjixrxgopu.cloudfront.net/cglms/uploads/medias/courses/diploma_hardware_networking.jpg',
    desc:"Computer Hardware and Networking is an intriguing field in today's world. The Advanced Diploma in hardware and Networking "
    // offers students a comprehensive overview of the subject with all the necessary details. At the end of this course, students will be able to practice and demonstrate PC hardware, operating systems, fundamental and advanced networking, Cisco Router & Switch administration and different server administrations.'
  },
  {
    name:'Diploma in Corporate Management',
    img:'https://dcbdjixrxgopu.cloudfront.net/cglms/uploads/medias/courses/diploma_corporate_management.jpg',
    desc:'The course Diploma in Corporate Management (DICM) aims at training participants in fundamentals of Accounts,'
    // basics of Tally.ERP 9, Direct and Indirect tax, Banking and Financial Management, Human Resource Management, and Marketing Management.On completion of the course, the participants will learn about various corporate processes and grow capable of finding placement opportunities as management interns or trainees.
    
  },
  {
    name:'Diploma in Hospitality Management',
    img:'https://dcbdjixrxgopu.cloudfront.net/cglms/uploads/medias/courses/diploma_hospitality_management.jpg',
    desc:'A course of hospitality management focuses on the application of management principles in the field of Hospitality.'
  },
  {
    name: "Bachelor of Engineering",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_of_Engineering.jpg",
    desc: ["Top Destinations: Germany, Netherlands, Sweden","Why: Tuition free or low-cost public universities, strong industry links with Siemens, Philips, Volvo; post-study work visas up to 18-24 months.","Specialisations: Computer Science, AI, Electrical, Civil, Mechanical, Mechatronics, Engineering Management, IT, Electronics & Comms."]
  },
  {
    name: "Bachelor of Management",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_of_Management.jpg",
    desc: ["Top Destinations: UK, Ireland, Singapore","Why: English-speaking markets, global financial hubs, paid placement years.","Specialisations: Business Mgmt, International Business, Industrial Mgmt."]
  },
  {
    name: "Bachelor of Arts",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_of_Arts.jpg",
    desc: ["Top Destinations: France, Spain, Latvia","Why: Rich cultural heritage, multilingual campuses, affordable tuition.","Specialisations: Humanities, Mass Comm, Int’l Relations, Public Relations, Music, Art & Film."]
  },
  {
    name: "Bachelor of Fashion Design",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_of_Fashion_Design.jpg",
    desc: ["Top Destinations: France (Paris), Italy (Milan), UK (London)","Why: Global fashion weeks, industry mentors, internship pipelines."]
  },
  {
    name: "Bachelor in Health Care",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_in_Health_Care.jpg",
    desc: ["Top Destinations: USA, Sweden, Netherlands","Why: World-class public-health systems, research hospitals.","Specialisations: Public Health, Healthcare Mgmt, Admin."]
  },
  {
    name: "Bachelor in Hospitality & Tourism",
    img: "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/ln_Bachelor_in_Hospitality_Tourism.jpg",
    desc: ["Top Destinations: Switzerland, Spain, Dubai","Why: Hospitality heritage, luxury tourism hubs, paid training semesters.","Specialisations: Hospitality Mgmt, Tourism, Culinary Arts, Hotel Mgmt."]
  }
]

export const postgraduatePathways  = [
  {
    program: "M.Eng. / MSc Engineering",
    bestCountries: ["Germany", "Sweden", "Ireland"],
    hook: "R&D clusters, EU Blue Card routes"
  },
  {
    program: "Master in Management",
    bestCountries: ["France", "UK", "Netherlands"],
    hook: "Triple‑Crown schools + 1‑year work visa"
  },
  {
    program: "Master of Arts",
    bestCountries: ["UK", "Spain"],
    hook: "Creative industries, global media houses"
  },
  {
    program: "Master of Fashion Design",
    bestCountries: ["France", "Italy"],
    hook: "Couture capital internships"
  },
  {
    program: "Masters in Health Care",
    bestCountries: ["USA", "Sweden"],
    hook: "Healthcare innovation funding"
  },
  {
    program: "Masters in Hospitality",
    bestCountries: ["Switzerland", "Dubai"],
    hook: "Five‑star campus hotels, tax‑free careers"
  }
];
